import { Component, SimpleChanges, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { eGENA_Checkliste } from '../../../../visionet/Checkliste';
import { GlobalsSingleton } from '../../../../app/core/GlobalsSingleton';


@Component({
	selector: 'ABCDESucheTablet',
	templateUrl: 'ABCDESuche.html'
})

export class ABCDESucheTabletComponent {

	@Input()
	abcdeIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	@Input()
	curSearchResultChecklists: eGENA_Checkliste[]
	@Input()
	ausgewaehlterPatiententyp: string;
	@Input()
	activeSearch: string = ''



	abcdeActive: string = "";

	constructor(public globals: GlobalsSingleton) {
	}


	/**	=== Visionet(sl) ==========
	 *
	 *	Lade die Trefferliste für den Buchstaben (A, B, C, D, E) in die aktuelle Trefferliste
	 *	Und speichere in abcdeActive den Index des Buchstaben (A=0, ..., E=4)
	 */
	ladeTrefferFuerABCDE_Suche(letter : string) : void {
		this.curSearchResultChecklists = this.abcdeIndex[letter];
		this.abcdeActive = letter;
	}

}



// WEBPACK FOOTER //
// ./src/components/Suche/ABCDESuche/Tablet/ABCDESuche.ts